module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_gc_spzd.de691b43.png";